export default function SectionHeader({ overline, title, sub, align = "left", dark = false }) {
  return (
    <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {overline && (
        <div className="flex items-center gap-3 mb-4">
          <span className={`block w-10 h-px ${dark ? "bg-terracotta" : "bg-terracotta"}`} />
          <p className={`text-[11px] font-medium uppercase tracking-[0.25em] ${dark ? "text-terracotta" : "text-medblue"}`}>
            {overline}
          </p>
        </div>
      )}
      <h2 className={`font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight ${dark ? "text-ivory" : "text-ink"}`}>
        {title}
      </h2>
      {sub && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-ivory/60" : "text-ink/60"}`}>
          {sub}
        </p>
      )}
    </div>
  );
}
